import { Stack, Typography, SxProps, Box } from '@mui/material';
import { subtitleSX, titleSX } from '@/components/blocks/DpLibrary/DpTitles/style/main';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import React from 'react';
import { DpContainer } from '@/components/blocks/DpContainer';
import { combineSX } from '@/utils/combineSX';

// eslint-disable-next-line complexity
export const DpTitles = ({
	title,
	subtitle,
	children,
	framesx,
	sx,
	...props
}: {
	title: string;
	subtitle?: string;
	sx?: SxProps;
	framesx?: SxProps;
	children?: React.ReactNode;
}) => {
	const isMobile = useIsMobile();

	return (
		<DpContainer
			withoutmargin
			framesx={combineSX([
				{ marginBottom: { xs: '30px', sm: '30px' } },
				...(Array.isArray(framesx) ? framesx : [framesx]),
			])}
		>
			{isMobile ? (
				<React.Fragment>
					<Box alignItems={'center'} {...props}>
						{title ? (
							<Typography component="h1" sx={titleSX}>
								{title}
							</Typography>
						) : null}
					</Box>
					<Box>
						{subtitle || children ? (
							<Typography component={'h2'} sx={subtitleSX}>
								{subtitle || children}
							</Typography>
						) : null}
					</Box>
				</React.Fragment>
			) : (
				<Stack alignItems={'center'} {...props}>
					{title ? (
						<Typography component="h1" sx={titleSX}>
							{title}
						</Typography>
					) : null}
					{subtitle || children ? (
						<Typography
							component={'h2'}
							sx={combineSX([subtitleSX, ...(Array.isArray(sx) ? sx : [sx])])}
						>
							{subtitle || children}
						</Typography>
					) : null}
				</Stack>
			)}
		</DpContainer>
	);
};
